export const PIN_POOL_FORM = {
  ppForm: document.querySelector('#aafp_driver-pin-pool') as HTMLFormElement,
  ppActive: document.querySelector('#aafp_pin-pool-switch') as HTMLInputElement
}

export const VEHICLE_POOL_FORM = {
  vpForm: document.querySelector('#aafp_vehicle-pin-pool') as HTMLFormElement,
  vpActive: document.querySelector('#aafp_vehicle-pool-switch') as HTMLInputElement
}

export const COMMON_FORM_ELEMENTS = {
  ceCustomerName:  document.querySelector('#aafp_form-customer-name')  as HTMLInputElement,
  ceCardGroupName: document.querySelector('#aafp_form-card-group-name') as HTMLInputElement,
  ceAddPinNumber: document.querySelector('#aafp_add-pin-number') as HTMLElement,
  cePinNumberInput: document.querySelector('#aafp_new-pin-number') as HTMLInputElement,
  cePinDescriptionInput: document.querySelector('#aafp_new-description') as HTMLInputElement,
  ceError: document.querySelector('.error-one') as HTMLElement,
  ceExport: document.querySelector('#download-csv-file') as HTMLElement,
  ceOptional: document.querySelectorAll<HTMLElement>('.aafp_pin-pool-optional'),
  ceAddModal: document.querySelector('#pinAddModal') as HTMLElement,
  ceWarningModal: document.querySelector('#pinWarningModal') as HTMLElement,
  ceAddPinForm: document.querySelector('#aafp_pin-pool-form') as HTMLFormElement,
  ceSubmitButton: document.querySelector('#aafp_pin-new-submit') as HTMLButtonElement,
  ceActiveWarning: document.querySelector('.aafp_pin-pool-warning') as HTMLElement,
}

export const DRIVER_ASK_FOR_ID = 1;
export const VEHICLE_ASK_FOR_ID = 5;

export const PIN_POOL_ACTIONS = {
  ADDPOOL: 'add_pool',
  ADDPIN: 'add_pin',
  REMOVEPOOL: 'remove_pool',
  REMOVEINDIVIDUALPIN: 'remove_individual_pin',
}